import React from 'react';

const StarFill: React.FC = () => (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_185_11668)">
            <path
                d="M5.86927 25.2199C5.24201 25.5421 4.53026 24.9775 4.65701 24.2566L6.00576 16.5601L0.28089 11.0993C-0.253735 10.5884 0.0241399 9.6544 0.740765 9.55352L8.70002 8.42101L12.249 1.38024C12.5691 0.745648 13.4353 0.745648 13.7554 1.38024L17.3044 8.42101L25.2636 9.55352C25.9803 9.6544 26.2581 10.5884 25.7219 11.0993L19.9986 16.5601L21.3474 24.2566C21.4741 24.9775 20.7624 25.5421 20.1351 25.2199L12.9998 21.549L5.86764 25.2199H5.86927Z"
                fill="#DDC160"
            />
        </g>
        <defs>
            <clipPath id="clip0_185_11668">
                <rect width="26" height="26.0347" fill="white" transform="translate(0 0.0917969)" />
            </clipPath>
        </defs>
    </svg>
);

export default StarFill;
